export default "__VITE_ASSET__Wnm6SbW3__"